import React, { useRef, useEffect } from 'react';
import './AddPageComponent.css'; // Erstellen Sie eine CSS-Datei für das Styling des Modals

const CreatePageModal = ({ showModal, setShowModal, pageName, setPageName, pageRoute, setPageRoute, createNewPage, userUsername }) => {
    const modalRef = useRef();

    // Event-Listener, der bei Klick außerhalb des Modals dieses schließt
    useEffect(() => {
        const clickHandler = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                setShowModal(false);
            }
        };

        // Prevent keystrokes from leaking through modal
        const keyHandler = (event) => {
            // Stop all keyboard events from propagating when modal is open
            event.stopPropagation();
            
            // Handle Enter key to submit
            if (event.key === 'Enter' && pageName.trim() && pageRoute.trim()) {
                createNewPage();
            }
            
            // Handle Escape key to close
            if (event.key === 'Escape') {
                setShowModal(false);
            }
        };

        if (showModal) {
            document.addEventListener('mousedown', clickHandler);
            document.addEventListener('keydown', keyHandler, true); // Use capture phase
            
            // Prevent scrolling on body when modal is open
            document.body.style.overflow = 'hidden';
        }

        return () => {
            document.removeEventListener('mousedown', clickHandler);
            document.removeEventListener('keydown', keyHandler, true);
            document.body.style.overflow = 'unset';
        };
    }, [setShowModal, showModal, pageName, pageRoute, createNewPage]);

    return (
        showModal && (
            <div className="page-modal-overlay">
                <div className="page-modal-container" ref={modalRef}>
                    <div className="page-modal-header">
                        <div className="page-modal-header-content">
                            <i className="fas fa-plus-circle page-modal-icon"></i>
                            <h2 className="page-modal-title">Add New Page</h2>
                        </div>
                        <div className="page-modal-url-preview">
                            <span className="page-modal-url-text">bonusclub.link/{userUsername}/</span>
                        </div>
                    </div>
                    
                    <div className="page-modal-form">
                        <div className="page-modal-field">
                            <label className="page-modal-label">
                                Page Name
                            </label>
                            <input
                                type="text"
                                value={pageName}
                                onChange={(e) => {
                                    const name = e.target.value;
                                    setPageName(name);
                                    // Auto-generate route if it's empty
                                    if (!pageRoute) {
                                        const autoRoute = name.toLowerCase().replace(/[^a-z0-9]/g, '');
                                        setPageRoute(autoRoute);
                                    }
                                }}
                                onKeyDown={(e) => {
                                    e.stopPropagation(); // Prevent event bubbling
                                    if (e.key === 'Enter' && pageName.trim() && pageRoute.trim()) {
                                        createNewPage();
                                    }
                                }}
                                placeholder="About, Contact, Services..."
                                className="page-modal-input"
                                autoFocus
                            />
                        </div>
                        
                        <div className="page-modal-field">
                            <label className="page-modal-label">
                                Page Route
                            </label>
                            <div className="page-modal-route-container">
                                <span className="page-modal-route-prefix">/</span>
                                <input
                                    type="text"
                                    value={pageRoute}
                                    onChange={(e) => setPageRoute(e.target.value.toLowerCase().replace(/[^a-z0-9-]/g, ''))}
                                    onKeyDown={(e) => {
                                        e.stopPropagation(); // Prevent event bubbling
                                        if (e.key === 'Enter' && pageName.trim() && pageRoute.trim()) {
                                            createNewPage();
                                        }
                                    }}
                                    placeholder="about, contact, imprint..."
                                    className="page-modal-route-input"
                                />
                            </div>
                        </div>
                    </div>
                    
                    <div className="page-modal-actions">
                        <button 
                            className="page-modal-btn page-modal-btn-secondary" 
                            onClick={() => setShowModal(false)}
                        >
                            Cancel
                        </button>
                        <button 
                            className="page-modal-btn page-modal-btn-primary" 
                            onClick={createNewPage}
                            disabled={!pageName.trim() || !pageRoute.trim()}
                        >
                            Add Page
                        </button>
                    </div>
                </div>
            </div>
        )
    );
};

export default CreatePageModal;
